import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import * as appActions from '../../actions/appActions';
import * as notificationsActions from '../../actions/notificationsActions';

import ProductsHeader from './tableHeader';
import TableRow from './tableRow';
import AddNonUserForm from './addNonUserForm';

const getTdWidth = length => {
    return { width: `calc(100% / ${length})` };
};

class ManageNotificationsTable extends React.PureComponent {
    state = {
        showAddUserForm: false,
        fixedHeader: false,
    };

    startScrolling = false;

    headerOffset = 0;

    headerHeight = 0;

    tableWidth = 'auto';

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    onDeleteUser = id => {
        this.props.deleteNonUser(id, this.props.popNonUser);
    };

    getProductsList = () => {
        const { marketId, isBroker, userProducts: products } = this.props;

        return marketId && products && !isBroker ? products.filter(p => +p.market_id === +marketId) : products;
    };

    handleScroll = e => {
        if (this.props.isCustomNotificationPopupVisible) {
            return;
        }

        if (!this.startScrolling && this.thead && this.table) {
            this.headerOffset = this.thead.getBoundingClientRect().top;
            this.headerHeight = this.thead.offsetHeight;
            this.tableWidth = this.table.getBoundingClientRect().width;
        }
        this.startScrolling = true;
        this.setState({
            fixedHeader: e.target.scrollTop >= this.headerOffset,
        });
    };

    showForm = () => {
        this.setState({
            showAddUserForm: true,
        });
    };

    hideForm = () => {
        this.setState({
            showAddUserForm: false,
        });
    };

    render() {
        const { users, nonusers, isApprovedCompany } = this.props;
        const products = this.getProductsList();
        const { fixedHeader } = this.state;

        const productsIds = products.map(p => p.id);
        const cellWidth = getTdWidth(products.length + 1);

        return (
            <div
                className={`manageNotifications table${fixedHeader ? ' fixedHeader' : ''}`}
                ref={node => {
                    this.table = node;
                }}
            >
                <ProductsHeader
                    products={products}
                    cellWidth={getTdWidth(products.length + 1)}
                    tableWidth={this.tableWidth}
                    ref={node => {
                        this.thead = node;
                    }}
                />
                <div className="tbody" style={{ marginTop: fixedHeader ? `${this.headerHeight}px` : '0px' }}>
                    {users && users.length ? (
                        <React.Fragment>
                            <div className="separator">
                                <div className="separator-limiter">Users:</div>
                            </div>
                            {users.map(item => (
                                <TableRow
                                    key={`nonuser${item.user_id}`}
                                    user={item}
                                    userType="users"
                                    productsIds={productsIds}
                                    cellWidth={cellWidth}
                                    isApprovedCompany={isApprovedCompany}
                                    deleteUser={this.onDeleteUser}
                                    setNotification={this.props.setNotificationsData}
                                    unsetNotification={this.props.unsetNotificationsData}
                                />
                            ))}
                        </React.Fragment>
                    ) : null}
                    <br />
                    <div className="separator">
                        <div className="separator-limiter">
                            Non users: <div className="sq-button sq-button-add" onClick={this.showForm} />
                        </div>
                    </div>
                    {this.state.showAddUserForm && (
                        <AddNonUserForm
                            productsIds={productsIds}
                            companyId={this.props.companyId}
                            hideForm={this.hideForm}
                            cellWidth={cellWidth}
                            joinNonUser={this.props.joinNonUser}
                            addNonUser={this.props.addNonUser}
                        />
                    )}
                    {nonusers && nonusers.length
                        ? nonusers.map(item => (
                              <TableRow
                                  key={`nonuser${item.entity_id}`}
                                  user={item}
                                  userType="nonusers"
                                  productsIds={productsIds}
                                  cellWidth={cellWidth}
                                  isApprovedCompany={isApprovedCompany}
                                  deleteUser={this.onDeleteUser}
                                  setNotification={this.props.setNotificationsData}
                                  unsetNotification={this.props.unsetNotificationsData}
                              />
                          ))
                        : null}
                </div>
            </div>
        );
    }
}

ManageNotificationsTable.propTypes = {
    isCustomNotificationPopupVisible: PropTypes.bool.isRequired,

    userProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    companyId: PropTypes.number,
    marketId: PropTypes.number,
    isBroker: PropTypes.bool,
    isApprovedCompany: PropTypes.bool,

    users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    nonusers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    setNotificationsData: PropTypes.func.isRequired,
    unsetNotificationsData: PropTypes.func.isRequired,
    deleteNonUser: PropTypes.func.isRequired,
    addNonUser: PropTypes.func.isRequired,
    popNonUser: PropTypes.func.isRequired,
    joinNonUser: PropTypes.func.isRequired,
};

ManageNotificationsTable.defaultProps = {
    companyId: null,
    isApprovedCompany: true,
    marketId: null,
    isBroker: false,
};

export default connect(
    state => ({
        users: state.notifications.users,
        nonusers: state.notifications.nonusers,
        isCustomNotificationPopupVisible: state.notifications.isCustomNotificationPopupVisible,
        userProducts: state.user.userInfo.products,
        user: state.user,
    }),
    dispatch => ({
        ...bindActionCreators({ ...appActions, ...notificationsActions }, dispatch),
    }),
)(ManageNotificationsTable);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/notificationsTable.js